import { Component } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { Router } from '@angular/router';
import { MeetingService } from '../../services/meeting.service';
import { ToasterService} from 'angular2-toaster';
import { CookieService } from 'angular2-cookie/services/cookies.service';

declare var document: any;
declare var $: any;

@Component({
  selector: 'app-savedcard',
  templateUrl: './savedcard.component.html',
  styleUrls: ['./savedcard.component.css']
})
export class SavedcardComponent {

  user: any = [];
  authcode: any;
  busy: Promise<any>;
  avail_hours: any;
  allcards: any = [];
  allyear: any = [];
  allmonth: any = [];
  interval: any;
  cs_msg: any;
  err_msg: any;

  constructor(private storage: LocalStorageService, public router: Router, private _cookieService: CookieService,
              public meetingService: MeetingService, private toasterService: ToasterService) {

      const val = this.storage.get('user');
      if (val) {
        this.user = val;
        // // console.log(this.user);
        this.authcode = val[0].authcode;
      } else {
        const link = ['/login'];
        this.router.navigate(link);
      }

      const min = new Date().getFullYear();
      const max = min + 20;
      const select = document.getElementById('year');

      for (let i = min; i <= max; i++) {
        this.allyear.push(i);
      }
      this.allmonth = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];

      this.cs_msg = this._cookieService.get('save_msg');
      // // console.log(this.u_msg);
      window.scrollTo(0, 0);
      this.interval = setTimeout(() => {
        this._cookieService.remove('save_msg');
        this.cs_msg = '';
        this.err_msg = '';
        $('.alert').fadeTo(2000, 500).slideUp(500, function() {
           $('.alert').slideUp(500);
        });
      }, 30000);

      $(document).ready(function() {
        // alert("hello");
        // // console.log("hello");
        $('body').on('click', '.fa-chevron-down', function() {
          $(this).removeClass('changepurpose');
          $('.changepurpose').addClass('fa-chevron-down');
          $('.changepurpose').removeClass('fa-chevron-up');
          $(this).toggleClass('fa-chevron-down fa-chevron-up');
          $(this).addClass('changepurpose');
        });
        $('body').on('click', '.fa-chevron-up', function() {
          $(this).removeClass('changepurpose');
          $('.changepurpose').addClass('fa-chevron-down');
          $('.changepurpose').removeClass('fa-chevron-up');
          $(this).toggleClass('fa-chevron-up fa-chevron-down');
          $(this).addClass('changepurpose');
        });
      });

      this.GetSavedCards();

  }

  getavailHours() {
    this.meetingService.getavailHours(this.authcode).subscribe(response => {
      if (response) {
        if (+ response.success === -1) {
          this.logOut(response.message);
        } else {
        // console.log(response);
        this.avail_hours = response.hours;
        this.user[0].hours = this.avail_hours;
        this.storage.set('user', this.user);
      }
      } else {
        // console.log("error");
      }
    });
  }

  GetSavedCards() {
    this.busy = this.meetingService.GetSavedCards(this.authcode).subscribe(response => {
      if (response) {
        if ( +response.success === -1) {
          this.logOut(response.message);
        } else {
        this.allcards = response;
        const date = new Date().getFullYear();
        for ( let i = 0; i < this.allcards.length; i++) {
          // // console.log(date);
          const stdate = date.toString();
          const out: string = stdate.substring(0, 2);
          this.allcards[i].cardyear = out + this.allcards[i].cardyear;
        }
        // console.log(this.allcards);
        this.getavailHours();
      }
      } else {
        // console.log("error");
      }
    });
  }

  addNewCard() {
    const link = ['/addnewcard'];
    this.router.navigate(link);
  }

  deleteSavedCard(card) {
    // console.log(card);
    this.meetingService.deleteSavedCard(this.authcode, card.cardid).subscribe(response => {
      if (response) {
        if (+ response.success === -1) {
          this.logOut(response.message);
        } else {
        // console.log(response);
        if (response.success === 1) {
          this.cs_msg = response.message;
          window.scrollTo(0, 0);
          this.GetSavedCards();
        } else {
          this.err_msg = response.message;
          window.scrollTo(0, 0);
        }
      }
      } else {
        // console.log("error");
      }
    });
  }

  getSavedCard() {
    // this.eventremember();
    if (this.storage.get('open_from_addhours') && this.storage.get('open_from_addhours') === 'yes') {
      // $('#saved_card').modal('hide');
      // var cardid = card.cardid;
      // var cvv = document.getElementById('cvv_'+cardid).value;
      // this.storage.set('cardid',cardid);
      // this.storage.set('cvvnum',cvv);
      const link = ['/makepayment'];
      this.router.navigate(link);
    }
  }

  addhoursqry(id) {
    // // console.log(id);
    // this.eventremember();
    const hour = document.getElementById('miss_hour').value;
    // // console.log(hour);

    const cid = this.storage.get('select_city_id') ? this.storage.get('select_city_id') : '0';

    if (hour === 5) {
      window.open('https://www.opusmeetingrooms.com/omrcc/?juid=' + id + '&price2=1&city=' + cid, '_blank');
    } else if (hour === 15) {
      window.open('https://www.opusmeetingrooms.com/omrcc/?juid=' + id + '&price3=1&city=' + cid, '_blank');
    } else {
      window.open('https://www.opusmeetingrooms.com/omrcc/?juid=' + id + '&price1=' + hour + '&city=' + cid, '_blank');
    }

  }

  goToProfile() {
    const link = ['/profile'];
    this.router.navigate(link);
  }

  updateSavedCard(card) {
    // console.log(card);
    const cvv = document.getElementById('cvv_' + card.cardid).value;
    const address = document.getElementById('address_' + card.cardid).value;
    const month = document.getElementById('month_' + card.cardid).value;
    const year = document.getElementById('year_' + card.cardid).value;
    // console.log(cvv);
    // console.log(address);
    // console.log(month);
    // console.log(year);
    this.meetingService
    .updateSavedCard(
      this.authcode, cvv, address, month, year, card.cardid, card.nameoncard, card.billingcity, card.billingzip, card.billingstate
    )
    .subscribe(response => {
      if (response) {
        if (+ response.success === -1) {
          this.logOut(response.message);
        } else {
        // console.log(response);
        if (response.success === 1) {
          this.cs_msg = response.message;
          window.scrollTo(0, 0);
        } else {
          this.err_msg = response.message;
          window.scrollTo(0, 0);
        }
      }
      } else {
        // console.log("error");
      }
    });
  }

  addHours(id) {
    // console.log(id);
    this.meetingService.GetSavedCards(this.authcode).subscribe(response => {
      if (response) {
        if (+ response.success === -1) {
          this.logOut(response.message);
        } else {
        if (response === '') {
          if (this.storage.get('select_city_id')) {
            const cid = this.storage.get('select_city_id');
            window.open('https://www.opusmeetingrooms.com/omrcc/?juid=' + id + '&city=' + cid, '_blank');
          } else {
            window.open('https://www.opusmeetingrooms.com/omrcc/?juid=' + id + '&city=0', '_blank');
          }
          // console.log("no saved card found");
        } else {
          this.storage.set('open_from_addhours', 'yes');
          setTimeout(function() {
              (<any>$('#myModal')).modal('show');
          }, 500);

        }
      }
      } else {
        // console.log("error");
      }
    });
  }

  signOut() {
    this.busy = this.meetingService.logout(this.authcode).subscribe(response => {
      if (response) {
        if (response[0].success === 1) {
          // console.log(response);
          this.storage.remove('user');
          this.storage.remove('select_city');
          this.storage.remove('select_city_id');
          this.storage.remove('select_building');
          this.storage.remove('select_building_id');
          this.storage.remove('select_room');
          this.storage.remove('select_room_id');
          this.storage.remove('seats');
          this.authcode = null;
          this._cookieService.put('msg', response[0].message);
          const link = ['/login'];
          this.router.navigate(link);
          // this.delete_cookie('user');
          // window.location.href = "http://ovo.dev.bluelightit.com/?message=Logout%20Successful";
        } else {
          this.toasterService.pop('error', response[0].message);
        }
      } else {
        // console.log("error");
      }
    }, (err) => {
      this.signOut();
    });
    // let link = ['/login'];
    // this.router.navigate(link);
  }

  logOut(message) {

          this.storage.remove('user');
          this.storage.remove('select_city');
          this.storage.remove('select_city_id');
          this.storage.remove('select_building');
          this.storage.remove('select_building_id');
          this.storage.remove('select_room');
          this.storage.remove('select_room_id');
          this.storage.remove('seats');
          this.authcode = null;
          this._cookieService.put('msg', message);
          const link = ['/login'];
          this.router.navigate(link);

  }

}
